import { ref } from 'vue';

export const gmailInboxCount = ref(0);
export const tareasCount = ref(0);
export const pedidosReclamarCount = ref(0);
export const gmailInboxTick = ref(0);

function toCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.floor(n);
}

export function setGmailInboxCount(value) {
  gmailInboxCount.value = toCount(value);
  return gmailInboxCount.value;
}

export function setTareasCount(value) {
  tareasCount.value = toCount(value);
  return tareasCount.value;
}

export function setPedidosReclamarCount(value) {
  pedidosReclamarCount.value = toCount(value);
  return pedidosReclamarCount.value;
}

export function aplicarConteoBandeja({ inboxTotal } = {}) {
  if (inboxTotal != null) {
    return setGmailInboxCount(inboxTotal);
  }
  return gmailInboxCount.value;
}

export function notificarCambioBandeja(payload = {}) {
  if (payload.inboxTotal != null) {
    setGmailInboxCount(payload.inboxTotal);
  }
  gmailInboxTick.value += 1;
}

export function resetNavBadges() {
  gmailInboxCount.value = 0;
  tareasCount.value = 0;
  pedidosReclamarCount.value = 0;
}
